module.exports = __webpack_public_path__ + "static/media/small.f69855f1.png";